/* tslint:disable:variable-name */
import {compact} from 'lodash'
import {TranslateResult} from 'vue-i18n'
import {Component, Prop, Vue, Watch} from 'vue-property-decorator'

/**
 * Separate a component from vue-i18n
 * It dose not support all of vue-i18n api
 * @mixin
 */
@Component
export default class Translation extends Vue {
  /**
   * Translation namespace
   */
  @Prop() translation: string

  /**
   * Save translation namespace
   */
  private __dTranslation: string = ''

  /**
   * Update __dTranslation
   * @param value
   * @private
   */
  @Watch('translation', {immediate: true})
  __translation(value) {
    this.__dTranslation = value
  }

  /**
   * Return translate data
   * same as vue-i18n $t
   * @link  https://kazupon.github.io/vue-i18n/api/#t
   * @param name
   * @param args
   */
  ts(name, ...args: any[]): TranslateResult {
    const nameChane = this._addNamespace(name)
    return this._checkAndRun('$t', nameChane, ...args)
  }

  tc(name, ...args: any[]) {
    const nameChane = this._addNamespace(name)
    return this._checkAndRun('$tc', nameChane, ...args)
  }

  te(name, ...args: any[]) {
    const nameChane = this._addNamespace(name)
    return this._checkAndRun('$te', nameChane, ...args)
  }

  td(name, ...args: any[]) {
    // const nameChane = this._addNamespace(name)
    return this._checkAndRun('$d', ...args)
  }

  tn(name, ...args: any[]) {
    const nameChane = this._addNamespace(name)
    return this._checkAndRun('$n', nameChane, ...args)
  }

  private _addNamespace(name): string {
    const {__dTranslation} = this
    return compact([__dTranslation, name]).join('.')
  }

  private _checkAndRun(name: string, ...args: any[]) {
    const func = this[name]
    if(typeof func !== 'function') {
      return args[0]
    }
    return func.call(this, ...args)
  }
}
